/** @format */

export enum FilterType {
  Standard,
  Category,
  Size,
  Price,
  Brand,
  Ratings,
}
